import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../Authentication/UserContext';
import axios from 'axios'
import BaseUrl from '../../BaseUrl'
import homeImgIcon from '../../Images/homeImgIcon.png'
import ComingSoon from '../../Images/ComingSoon.jpg'
import KitsHoverImg from '../../Images/Kits-Hover-Img.jpg'
import Loader from '../../Images/loader.gif'



const Home = ({ openCart }) => {
    const { setCart, cart ,DAmount,setDAmount } = useUser();
    const navigate = useNavigate();
    const [isAnimating, setIsAnimating] = useState(false);
    const [hoveredItem, setHovered] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const [itemsRes, setitemRes] = useState([]);

    const ItemDetPage = (obj) => {
        navigate("/itemdet", { state: { person: obj } });
    }
    const AddCartItems = (item) => {
        const itemExists = cart.some(cartItem => cartItem._id === item._id);

        if (!itemExists) {
            setCart([...cart, {
                _id: item._id,
                name: item.name,
                price: item.price,
                picture: item.picture,
                originalQuantity: item.quantity,
                quantity: 1,
            }]);
        }

        openCart();
    };

    useEffect(() => {
        window.scrollTo(0,0);
    }, [])
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const itemsRes = await axios.get(`${BaseUrl}/items`);
                setitemRes(itemsRes.data.message);
                console.log(itemsRes);
                setIsLoading(false);
            } catch (err) {
                console.log(err);
                setIsLoading(false);
            }
        };
        const fetchAmount = async () => {
            try {
                const itemsRes = await axios.get(`${BaseUrl}/delivery`);
                setDAmount(itemsRes.data.message[0].amount);
                console.log(itemsRes.data.message[0].amount);
                setIsLoading(false);
            } catch (err) {
                console.log(err);
                setIsLoading(false);
            }
        };

        setIsAnimating(true);
        fetchAmount();
        fetchData();
    }, []);
    

    return (
        <div className={`${isAnimating ? 'animate-fadeUp' : ''}`}>
            <section className={` bg-custom-image min-[1025px]:min-h-[37rem] min-[640px]:flex-row flex flex-col  flex-wrap px-[40px] min-h-[29rem] font-serif   ${isAnimating ? 'animate-fadeIn' : ''} `}>
                <div className={` min-[640px]:w-[50%] min-[426px]:pt-[150px] min-[1024px]:pt-[150px]  w-[100%] pt-[130px] pb-[130px] font-bold text-[40px] ${isAnimating ? 'animate-slideInTop' : ''}`}>
                    <h1 className=' min-[770px]:text-5xl min-[1024px]:pb-[20px] min-[1024px]:text-6xl pt-[2rem] text-center text-4xl text-[blue] '>Empowering</h1>
                    <h1 className=' min-[770px]:text-5xl min-[1024px]:pb-[20px] min-[1024px]:text-6xl pt-[2rem] text-center text-4xl text-[skyblue]'>Creativity</h1>
                    <h1 className=' min-[770px]:text-5xl min-[1024px]:pb-[20px] min-[1024px]:text-6xl pt-[2rem] text-center text-4xl text-black'>with <span className='text-red-500'>STEM</span></h1>
                </div>
                <div className={` w-[100%] min-[640px]:w-[50%] flex justify-center items-center ${isAnimating ? 'animate-slideInRight' : ''}`}>
                    <img className={`  min-[640px]:h-[300px] min-[640px]:mt-[40px] min-[1024px]:h-[600px] min-[1024px]:w-[500px]  w-[350px] h-[400px] pt-[20px] `} src={homeImgIcon} alt='About Robo Image' />
                </div>
            </section>
            <h1 className='min-[426px]:text-2xl min-[769px]:text-start min-[769px]:ml-[50px] min-[769px]:text-4xl min-[1025px]:ml-[20px] min-[1081px]:text-5xl min-[1081px]:pt-[50px] min-[1081px]:ml-[45px] text-[24px] text-[#192A3D]  h-[54px] text-center font-extrabold  font-serif'>Latest Products</h1>
            <section className={`min-[1080px]:mt-[100px]  w-[100%] min-[1025px]:min-h-[37rem]  min-[712px]:space-x-4 min-[1025px]:grid min-[1025px]:grid-cols-3 min-[1025px]:object-cover  min-[1025px]:flex-nowrap justify-center space-x-0   flex flex-wrap `}>
                {
                    isLoading ?
                        <img className=' max-w-[150px] max-h-[150px] ' src={Loader} alt='loading' /> :
                        itemsRes.length > 0 ?
                            itemsRes.map((item, index) => (
                                <div key={index} className='min-[1025px]:text-[18px] min-[1081px]:w-[550px]  min-[1081px]:ml-[20px] pl-[18px] w-[350px]  mb-[60px] '>
                                    {
                                        item.picture ? <img className=' min-[1025px]:h-[320px] min-[1025px]:w-[450px] min-[1081px]:w-[320px] min-[1100px]:w-[400px] min-[1300px]:w-[450px]  rounded-[5%] hover:transform hover:-translate-y-3 transition-all duration-1000 ease-in-out hover:cursor-pointer'
                                            src={hoveredItem === index ? `${item.picture2}` : `${item.picture}`}
                                            alt={item.name}
                                            onClick={() => ItemDetPage(item)}
                                            onMouseEnter={() => setHovered(index)}
                                            onMouseLeave={() => setHovered(null)} /> : 'No Image'
                                    }
                                    <h1 className='text-black font-bold w-full  my-[20px] hover:text-red-600 hover:cursor-pointer' onClick={() => ItemDetPage(item)}>{item.name || 'none'}</h1>
                                    <h2 className='text-blue-700 font-bold  w-full  my-[20px]'>₨ {item.price || 'none'}    <span className='min-[1025px]:text-[14px] text-[12px] opacity-80  font-medium line-through '>₨ {parseInt(item.price) + (parseInt(item.price) * 0.2) || 'none'}</span></h2>
                                    {
                                        parseInt(item.quantity) !== 0 ?
                                            <button className=' bg-blue-700 rounded-[5%] w-[120px] h-[40px] text-white hover:bg-red-500 hover:cursor-pointer' onClick={() => AddCartItems(item)} >Add to cart</button> :
                                            <button className=' bg-red-500 rounded-[5%] w-[120px] h-[40px] text-white hover:bg-blue-500 hover:cursor-not-allowed'  >Out Of Stock</button>
                                    }
                                </div>
                            )) :
                            <h1 className='min-[426px]:text-xl min-[769px]:text-start min-[769px]:ml-[50px] min-[769px]:text-2xl min-[1025px]:ml-[20px] min-[1081px]:text-3xl min-[1081px]:pt-[50px] min-[1081px]:ml-[45px] text-[18px] text-[#192A3D]  h-[54px] text-center  font-serif'>No Item Found</h1>

                }
                {
                    itemsRes.length > 0 ?
                        <>
                            <div className='min-[1025px]:text-[18px] min-[1081px]:w-[550px] opacity-50 min-[1081px]:ml-[20px] pl-[18px] w-[350px]  mb-[60px] hover:cursor-not-allowed '>
                                <img className=' min-[1025px]:h-[320px] min-[1025px]:w-[450px] min-[1081px]:w-[320px] min-[1100px]:w-[400px] min-[1300px]:w-[450px]  rounded-[5%] hover:transform hover:-translate-y-3 transition-all duration-500' src={ComingSoon} alt='coming Soon' />
                                <h1 className='text-black font-bold w-full  my-[20px]  '>Mini-Techstarter</h1>
                                <h2 className='text-blue-700 font-bold  w-full  my-[20px]'>₨ 5500  <span className='min-[1025px]:text-[14px] text-[12px] opacity-80  font-medium line-through '>₨ 6600</span></h2>
                                <button className='bg-blue-700 rounded-[5%] w-[120px] h-[40px] text-white hover:cursor-not-allowed '>Add to cart</button>
                            </div>
                        </> : ''
                }

            </section>
        </div>

    )
}

export default Home